import { PricingCard } from "./PricingCard";
import { SectionHeading } from "./SectionHeading";
import { GlowOrb } from "./Glow";

const PLANS = [
  {
    id: "starter", index: "01", name: "Artist Starter", price: "$19.99", cta: "Get started",
    blurb: "For independent artists building their first releases.",
    features: ["Artist profile and shareable EPK", "Full opportunity feed", "5 pitches per month", "Core streaming analytics", "Release distribution workspace"],
  },
  {
    id: "pro", index: "02", name: "Artist Pro", price: "$69.99", cta: "Get Pro", popular: true,
    blurb: "For artists and teams releasing consistently.",
    features: ["Unlimited pitches", "Pitch status tracking and placement history", "Full analytics with market breakdown", "Priority submission review queue", "Campaign Builder access", "Royalty and revenue reporting"],
  },
  {
    id: "elite", index: "03", name: "Artist Elite", price: "$135", cta: "Go Elite",
    blurb: "For career artists running serious campaigns.",
    features: ["Everything in Artist Pro", "Dedicated pitch strategist review", "Priority access to paid opportunities", "Advanced audience and market intelligence", "Campaign performance reviews", "Direct support line"],
  },
];

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="relative overflow-hidden border-t border-white/10 bg-pa-black">
    <GlowOrb className="left-1/2 top-1/2 h-[700px] w-[700px] -translate-x-1/2" strength="md" />
    <div className="relative mx-auto max-w-[1400px] px-5 py-section-sm sm:px-8 lg:px-12 lg:py-section">
      <div className="grid gap-10 lg:grid-cols-12">
        <SectionHeading className="lg:col-span-7" eyebrow="Pricing / 07" lines={["Start where", "you are."]} label="Start where you are." />
        <p className="self-end text-base leading-relaxed text-pa-muted md:text-lg lg:col-span-5">
          Choose a plan, download the app, and subscribe inside Pitchally when you create your account. Prices in USD.
        </p>
      </div>
      <div className="mt-16 grid items-stretch gap-6 lg:mt-24 lg:grid-cols-3">
        {PLANS.map((p, i) => <PricingCard key={p.id} plan={p} delay={i * 0.08} />)}
      </div>
    </div>
  </section>
);
